import { render, staticRenderFns } from "./TagNew.vue?vue&type=template&id=680176d6&"
var script = {}
import style0 from "./TagNew.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('680176d6')) {
      api.createRecord('680176d6', component.options)
    } else {
      api.reload('680176d6', component.options)
    }
    module.hot.accept("./TagNew.vue?vue&type=template&id=680176d6&", function () {
      api.rerender('680176d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TagNew.vue"
export default component.exports